import React from 'react';
import { ABOUT, ABOUT_NOTES } from '../mock';

export default function About() {
  return (
    <section
      id="about"
      className="py-24 md:py-32"
      style={{ background: 'var(--ink)', color: 'var(--cream)' }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mono text-[11px] uppercase tracking-[0.2em] mb-10" style={{ color: 'var(--terracotta)' }}>
          § 04 · About
        </div>

        <div className="grid md:grid-cols-12 gap-8 md:gap-12">
          <div className="md:col-span-8">
            <p
              className="display"
              style={{
                fontSize: 'clamp(1.75rem, 3.6vw, 3rem)',
                lineHeight: 1.18,
                fontWeight: 400,
                color: 'var(--cream)',
              }}
            >
              {ABOUT.body[0]}
            </p>

            <p className="mt-8 text-[15px] md:text-[17px] leading-relaxed" style={{ color: '#d4cbbc' }}>
              {ABOUT.body[1]}
            </p>

            {/* Beliefs strip */}
            <div className="mt-12 md:mt-16 pt-10 border-t" style={{ borderColor: 'rgba(244,239,230,0.12)' }}>
              <div className="mono text-[10px] uppercase tracking-[0.22em] mb-4" style={{ color: '#d4b896' }}>
                {ABOUT.beliefsLabel}
              </div>
              <p
                className="serif"
                style={{
                  fontSize: 'clamp(1.1rem, 1.8vw, 1.5rem)',
                  lineHeight: 1.4,
                  fontStyle: 'italic',
                  color: 'var(--cream)',
                  fontWeight: 400,
                  letterSpacing: '-0.005em',
                }}
              >
                {ABOUT.beliefs}
              </p>
            </div>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <ul className="space-y-6 md:border-l md:pl-8" style={{ borderColor: 'rgba(244,239,230,0.15)' }}>
              {ABOUT_NOTES.map((n) => (
                <li key={n.label}>
                  <div className="mono text-[10px] uppercase tracking-[0.2em] mb-1.5" style={{ color: '#d4b896' }}>
                    {n.label}
                  </div>
                  <div className="text-[14px] leading-relaxed" style={{ color: 'var(--cream)' }}>
                    {n.value}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
